"use strict";

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Fade;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../"));

var _gsap = _interopRequireDefault(require("gsap"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/AniLink/Fade.js";

var fade = function fade(_ref) {
  var length = _ref.exit.length,
      node = _ref.node,
      direction = _ref.direction;
  var duration = direction === 'out' ? length + length / 4 : length;
  var opacity = direction === 'in' ? 1 : 0;
  var scrollTop = document.scrollingElement && document.scrollingElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  var holdPosition = direction === 'out' ? {
    overflowY: 'hidden',
    height: '100vh',
    scrollTop: scrollTop
  } : {};
  return _gsap.default.timeline().set(node, holdPosition).fromTo(node, {
    opacity: !opacity
  }, {
    opacity: opacity,
    duration: duration
  });
};

function Fade(_ref2) {
  var exit = _ref2.exit,
      entry = _ref2.entry,
      removedProp = _ref2.fade,
      duration = _ref2.duration,
      props = _objectWithoutProperties(_ref2, ["exit", "entry", "fade", "duration"]);

  var length = duration || 0.8;
  return /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({
    exit: {
      length: length,
      zIndex: 1,
      trigger: function trigger(_ref3) {
        var exit = _ref3.exit,
            node = _ref3.node;
        return fade({
          exit: exit,
          node: node,
          direction: 'out'
        });
      }
    },
    entry: {
      length: 0,
      trigger: function trigger(_ref4) {
        var exit = _ref4.exit,
            node = _ref4.node;
        return fade({
          exit: exit,
          node: node,
          direction: 'in'
        });
      }
    }
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 3
    }
  }), props.children);
}